import {AfterViewInit,  Directive, QueryList, ViewChildren, Component, ElementRef, ViewChild, OnInit, NgZone, Input, OnChanges, SimpleChanges} from '@angular/core';

import { ActionSheet, ActionSheetController, Config, NavController, ToastController,  ModalController, NavParams, PopoverController} from 'ionic-angular';

import { UserData } from '../../providers/user-data';

import moment from 'moment';
import { Http } from '@angular/http';

import { CommonData } from '../../providers/common-data';

import { AlertController } from 'ionic-angular';
import { ParkbewilligungenData, PbKategorieTyp, Laendercode } from './parkbewilligungen-data';
import { ParplatzData } from '../../providers/pp-data';
import { PbKundenData } from '../../providers/pbkunden-data';

import { AgGridAngular } from 'ag-grid-angular';
import { CompletePPService } from '../../providers/epautocomplete-service';
import { Observable } from 'rxjs';
import { Components } from "../../../../components";

import { PbKategorieSelection } from './pbkategorieselection/pbkategorieselection';
import { PbKundenSelection } from './pbkundenselection/pbkundenselection';

import { CompleteZoneService } from '../../providers/zoneautocomplete-service';
import { PbZonenData } from '../../providers/pbzonen-data';
import { MandantenData } from '../../providers/mandanten-data';



declare var navigator : any;
declare var device : any;
@Component({
  selector: 'parkbewilligungen-edit',
  templateUrl: 'parkbewilligungen-edit.html'
})
export class ParkbewilligungenEditPage  implements OnInit, OnChanges{
  sNormalColor = "primary";
  sCheckedColor = "secondary";
  pbkunden_id:number;
  pbperioden_id: number;
  oPb:any;
  oPeriodsDisplay:any;
  pbKunde: any = {};
  pbKennzeichen: any = [];
  pbkennzeichen_edited: string = "";
  existingParkkarten: any = [];
  customertab = "info";
  newPbKennzeichen :any = {};
  editingKennzeichen: any = {};
  statusUpdateTimer;
  viewmode: string = "edit";
  createstep: string = "customerselection"
  pbkatDisabled: boolean = false;
  inactiveStates = [6,13,8,9,11];  
  originalEmail : string;


  laenderCodes = Laendercode;

  public PbKategorieTyp = PbKategorieTyp;


  @ViewChild('pbGrid2') pbGrid2: AgGridAngular;
    @ViewChildren('kennzeichenSlide') slidingElements;
  constructor(
              private navParams: NavParams
            , public navCtrl: NavController
            , public userData: UserData
            , public toastCtrl: ToastController
            , public zone: NgZone
            , public common: CommonData
            , public http: Http
            , public modalCtrl: ModalController
            , public alertCtrl: AlertController
            , public pbData: ParkbewilligungenData
            , public ppData: ParplatzData
            , public kData: PbKundenData
            , public zonenData: PbZonenData
            , public mData : MandantenData
            , public completePPService: CompletePPService
            , public completeZoneService: CompleteZoneService
            , public popoverCtrl: PopoverController

            ) {
    //let selectedpp = navParams.get('pp');
    this.pbkunden_id = navParams.get('pbkunden_id');
    this.pbperioden_id = navParams.get('pbperioden_id');
    this.viewmode = navParams.get('viewmode');

    this.pbkatDisabled = (!userData.isAllowed('15','u'));
    
    //console.log(userData.isAllowed('15','u'));
    //this.oPb = {};



   }

   ionViewCanLeave(): boolean{
     
    let result = true;
    if(this.pbKunde.attributes.edited){
      result =  false;
    }
    for(let i =0; i< this.oPeriodsDisplay.length; i++){

      if(this.oPeriodsDisplay[i].period.attributes.edited && !this.oPeriodsDisplay[i].period.attributes.ignorechanges){
        result =  false;
      }
    }

    if(!result){
      let toast = this.toastCtrl.create({
        message: "Offene Änderungen speichern oder verwerfen.",
        position: 'top',
        cssClass: 'toast-error',
        duration: 3000
      });

      toast.present();   
      return false;
    }
    else{
      return true;
    }
   }

   ngOnInit() {
     this.initPb();
        
  }
  initPb(){
    this.oPeriodsDisplay = [];
    this.statusUpdateTimer = null;

    this.newPbKennzeichen.typ = 1;
    this.newPbKennzeichen.laendercode = this.laenderCodes.SCHWEIZ;
    if( !this.userData.isAllowed('15','u')){
      this.readonly();      
    }

    if(this.viewmode == 'create'){
      this.createstep = "customerselection";
      this.showKunden();
    }
    else{
      this.createstep = "";
    }    
    //console.log("common.maxDate");
    //console.log(common.maxDate);
    this.customertab = "info";

    if(this.pbkunden_id){

      this.pbData.viewallbycustomer(this.pbkunden_id).then(res => {
        //console.log(res);
        this.oPb = res;
        //console.log(this.oPb);
        this.pbkennzeichen_edited = "";

        if(!this.oPb.attributes.pbkennzeichen){
          this.pbKennzeichen = [];
        }
        else{
          this.pbKennzeichen = this.oPb.attributes.pbkennzeichen;
        }
        //console.log(this.oPb.attributes.pbkunde);
        if(this.oPb.attributes.pbkunde){
          this.pbKunde = this.oPb.attributes.pbkunde;
          this.originalEmail = this.oPb.attributes.pbkunde.email;
          this.loadParkkarten(this.pbKunde.id);
          this.pbKunde.attributes = {expanded: false};          
        }

        //console.log(this.oPb.attributes.periods);
        
        for(let i =0; i< this.oPb.attributes.periods.length; i++){
          let _expand = false;
          let pbkategorie;
          let pbstatus;
          
          if(this.oPb.attributes.periods[i].id == this.pbperioden_id){
            _expand=true;
          }        
          pbkategorie = this.pbData.pbcategories.find(x => x.id ===  this.oPb.attributes.periods[i].pbkategorie_id);
          //console.log(pbkategorie);
          pbstatus = this.pbData.pbstatus.find(x => x.id ===  this.oPb.attributes.periods[i].pbstatus_id);
          //console.log( this.oPb.attributes.periods[i]);
          this.oPeriodsDisplay.push({expanded:_expand, period: this.oPb.attributes.periods[i], selectedstatus: pbstatus, selectedkategorie:pbkategorie, tab:"info"});
          //console.log(this.oPb.attributes.periods[i]);
        }
        //console.log(this.oPeriodsDisplay);
        
      });    
    }

  }

  createPb(){

    this.createstep = "selectkat";
    //pd.period.valid_from
    let valid_from = moment.utc().startOf('day').add(1,'d').format('YYYY-MM-DDT00:00:00');
    
    let newperiod = {
        expanded:true      
      , period: 
        {
          attributes: {
            edited:true
            ,pbregelnbyperiode:[]
            , grundstuecke: []
            , pbzonen: []
            , parkbewilligung : {physisch:0}
            }
          , parkbewilligungen_id:-1
          , valid_from: valid_from
        }
      , selectedstatus: null
      , selectedkategorie:null
      , tab:"info"
    };
    this.oPeriodsDisplay.unshift(newperiod);    
  }

  showCategories(pd){

    let popover = this.popoverCtrl.create(PbKategorieSelection, {}, {cssClass: 'pbkatselection'});
    popover.onDidDismiss(async pbkat => {

      if(pd && pbkat){
        pd.selectedkategorie = pbkat;
        pd.period.pbkategorie_id = pbkat.id;
        pd.period.attributes.edited = "changed";
        pd.period.attributes.mandat = this.mData.mandateby(pbkat.mandate_id);
        //console.log(pd.period.attributes.mandat);
        this.calcDatum(pd.selectedkategorie, pd.period);

      }
    });
    popover.present({
      ev: event
    });    

  }


  calcDatum(pbkategorie, period){
    if(pbkategorie ){
      switch(pbkategorie.bestelltyp){
        case PbKategorieTyp.FixeDauer:
          period.valid_to = moment(period.valid_from).add(pbkategorie.dauer-1, 'days').format('YYYY-MM-DDT23:59:59');
          break;
        case PbKategorieTyp.FixerZeitraum:          
          period.valid_from = moment(pbkategorie.datum_von).format('YYYY-MM-DDT00:00:00');
          period.valid_to = moment(pbkategorie.datum_von).add(pbkategorie.dauer-1, 'days').format('YYYY-MM-DDT23:59:59');
          break;
        case PbKategorieTyp.Permanent: 
          period.valid_to = null;
          break;
      }
    }

  }


  showKunden(searchterm : string =""){
    
    let popover = this.popoverCtrl.create(PbKundenSelection, {searchterm: searchterm}, {cssClass: 'pbkundenselection'});
    popover.onDidDismiss(async pbkunde => {
      //console.log(pbkunde);
      if(!pbkunde){
        this.createstep = "customercreate";
        this.pbKunde = {kommunikation:"digital", attributes:{expanded: true}};
        this.loadParkkarten(-1);
      }
      else{
        //-- Load PbKunde -----
        this.pbKunde = pbkunde;
        this.loadParkkarten(this.pbKunde.id);
        if(pbkunde.attributes.pbkennzeichen){
          this.pbKennzeichen = pbkunde.attributes.pbkennzeichen;
        }
        else{
          this.pbKennzeichen = [];
        }
        this.pbkennzeichen_edited = "";
        this.createstep = "pbcreate";
        this.pbKunde.attributes = {expanded: false}; 
      }

    });
    popover.present({
      ev: event
    });    
    
  }

  loadParkkarten(pbkunden_id){
    if(!pbkunden_id || pbkunden_id<=0){
      this.existingParkkarten.lenght = 0;
    }
    else{
      this.pbData.existingParkkarten(pbkunden_id).then(res => {
        if(res){
          this.existingParkkarten = res;
        }
        else{
          this.existingParkkarten.lengt = 0;
        }
        
        //pd.period.attributes.pbregelnbycatid = res;
        //this.oSelectedKategorieRegeln = res;
      }); 
    }
  }

  pbKundeChange(event, pbkunde){
    pbkunde.attributes.edited = "changed";

  }
  pbPeriodChange(event, pd){
    //console.log("pbPeriodChange");
    pd.period.attributes.edited = "changed";
  }

  pbPeriodDateChange(event, pd){
    pd.period.attributes.edited = "changed";
     
    this.calcDatum(pd.selectedkategorie,pd.period );

  }

  async periodTabChanged(event, pd){
    //console.log("pbPeriodChange");
    
    if(pd.tab=='payments'){
      console.log(pd.period.id);
      let payments : any = await this.pbData.paymentsforperiod(pd.period.id);
      
      pd.period.attributes.payments = payments.payments;
    }
    
  }

  pbRegelnChanged(event, pd, regelindex){
    //console.log("pbRegelnChanged");    
    pd.period.attributes.edited = "changed";
    if(!pd.period.attributes.pbregelnbyperiode[regelindex].attributes.edited){
      pd.period.attributes.pbregelnbyperiode[regelindex].attributes.edited="changed";
    }
  }

  addPeriodRule(pd){
    console.log(pd.period.attributes.mandat.pb_zone_grundstuecke);
    console.log(pd.period.attributes);
    pd.period.attributes.edited = "changed";
    if(!pd.period.attributes.pbregelnbyperiode){
      pd.period.attributes.pbregelnbyperiode = [];      
    }
    //console.log(pd);
    if(!pd.period.attributes.pbregelnbyperiode.hasOwnProperty("attributes")){
      pd.period.attributes.pbregelnbyperiode.attributes = {};
    }
    pd.period.attributes.pbregelnbyperiode.attributes.edited="changed";
    let r:any = {name:"Regelname", zeit_von:"00:00:00", zeit_bis:"23:59:59", mo:1, di:1, mi:1, do:1, fr:1, sa:1, so:1, attributes:{typ:pd.period.attributes.mandat.pb_zone_grundstuecke, edited:"added"}};
    if((pd.period.attributes.mandat.pb_zone_grundstuecke === "zone")){
      if((pd.period.attributes.pbzonen.length>0)){
        r.attributes.pbzonen_id = pd.period.attributes.pbzonen[0].id;
      }
      else{
        this.common.showError('Dieser Parkbewilligung sind keine Zonen zugewiesen!');
        return;
  
      }
    }
    if((pd.period.attributes.mandat.pb_zone_grundstuecke === "grundstuecke") ){
      console.log("ist grundstueck!")
      console.log(pd.period.attributes.grundstuecke)
      if((pd.period.attributes.grundstuecke.length>0)){
        r.attributes.grundstuecke_grundid = pd.period.attributes.grundstuecke[0].grundid;
      }
      else{
        this.common.showError('Dieser Parkbewilligung sind keine Grundstücke zugewiesen!');
        return;
      }        
    }

    pd.period.attributes.pbregelnbyperiode.push(r)
  }  

  ngOnChanges(changes: SimpleChanges) {
    //console.log('changes');
    //console.log(changes);
    // changes.prop contains the old and the new value...
  }  
  refreshCategoryDetails($event, pd){    
    pd.selectedkategorie = this.pbData.pbcategories.find(x => x.id === pd.period.pbkategorie_id);
    //console.log($event);
    pd.period.attributes.edited = "changed";
    this.pbData.pbregelnbycatid(pd.period.pbkategorie_id).then(res => {
      //console.log(res);
      pd.period.attributes.pbregelnbycatid = res;
      //this.oSelectedKategorieRegeln = res;
    });    
    //console.log(this.oSelectedKategorie);
  }

  refreshStatusDetails($event, pd){    
    //console.log(pd);
    pd.selectedstatus = this.pbData.pbstatus.find(x => x.id === pd.period.pbstatus_id);
    pd.period.attributes.edited = "changed";
  }

  removePP(period, ppindex){
    period.attributes.edited = "changed";
    if(period.attributes.grundstuecke[ppindex].edited && period.attributes.grundstuecke[ppindex].edited == "removed"){
      delete period.attributes.grundstuecke[ppindex].edited;
     }
     else if(period.attributes.grundstuecke[ppindex].edited && period.attributes.grundstuecke[ppindex].edited == "added"){
      period.attributes.grundstuecke.splice(ppindex, 1); 
     }
     else{
      period.attributes.grundstuecke[ppindex].edited = "removed";
     }    
    //period.attributes.grundstuecke[ppindex].edited = "removed";
    //period.attributes.grundstuecke.splice(ppindex, 1); 
  }  

  removeZone(period, zoneindex){
    
    period.attributes.edited = "changed";
    if(period.attributes.pbzonen[zoneindex].attributes && period.attributes.pbzonen[zoneindex].attributes.edited && period.attributes.pbzonen[zoneindex].attributes.edited == "removed"){
      delete period.attributes.pbzonen[zoneindex].attributes.edited;
    }
    else if(period.attributes.pbzonen[zoneindex].attributes && period.attributes.pbzonen[zoneindex].attributes.edited && period.attributes.pbzonen[zoneindex].attributes.edited == "added"){
      period.attributes.pbzonen.splice(zoneindex, 1); 
    }
    else{       
      if(!period.attributes.pbzonen[zoneindex].hasOwnProperty("attributes")){
        period.attributes.pbzonen[zoneindex].attributes = {};
      }        
      period.attributes.pbzonen[zoneindex].attributes.edited = "removed";
     }   
     //console.log(period); 
  }  


  ngAfterViewInit(){
      
  }     

  addGrundstueck(event, gindex, period){
    //console.log(period);
    period.attributes.edited = "changed";

    let bpppresent = false;
    if(!period.attributes.grundstuecke){
      period.attributes.grundstuecke = [];
    }
    period.attributes.grundstuecke.forEach((grund,index) => {
      if(grund.grundid == event.grundid){
        bpppresent = true;
      }
    });
    
    if(bpppresent){
      let toast = this.toastCtrl.create({
        message: "Parkplatz bereits vorhanden",
        position: 'top',
        cssClass: 'toast-error',
        duration: 3000
      });

      toast.present();         
    }
    else{
      period.attributes.grundstuecke.push({grundid:event.grundid, edited:"added"});
    }
  }    
  addZone(event, zindex, period){
    //console.log(period);
    //console.log(event);
    period.attributes.edited = "changed";

    let bzonepresent = false;
    if(!period.attributes.pbzonen){
      period.attributes.pbzonen = [];
    }
    let newzone;
    period.attributes.pbzonen.forEach((zone,index) => {
      if(zone.id == event.id){
        bzonepresent = true;
      }
    });

    //-- zone auslesen --------
    
    this.zonenData.data.forEach((zone,index) => {
      if(zone.id == event.id){
        newzone = zone;
      }
    });


    if(bzonepresent){
      let toast = this.toastCtrl.create({
        message: "Zone bereits vorhanden",
        position: 'top',
        cssClass: 'toast-error',
        duration: 3000
      });

      toast.present();         
    }
    else{
      newzone.attributes = {};
      newzone.attributes.edited = "added";
      period.attributes.pbzonen.push(newzone);
    }
  }    
  deletePbKennzeichen(pbkennzeichen, idx){

    this.slidingElements.forEach(element => {
      element.close();
    });
    
    
    //this.kennzeichenSlide.closeOpened();
    if(pbkennzeichen.edited == "added"){
      this.pbkennzeichen_edited='changed';
      this.pbKennzeichen.splice(idx,1);
    }
    else{

      this.pbData.pbkennzeichenInUse(pbkennzeichen.id).then( (inUse) => {
        
        if(!inUse){
          this.pbkennzeichen_edited='changed';
          pbkennzeichen.edited="removed";
        }
        else{
          let toast = this.toastCtrl.create({
            message: "Kennzeichen ist einer Parkbewilligung zugewiesen und kann nicht gelöscht werden",
            position: 'top',
            cssClass: 'toast-error',
            duration: 5000
          });
    
          toast.present();      
        }

      });

    }
    
  }

  addPbKennzeichen(){
    this.pbkennzeichen_edited='changed';
    let k : any = {};
    Object.assign(k, this.newPbKennzeichen)
    k.kennzeichen = k.kennzeichen.toUpperCase().trim().replace(/\s/g, '');
    let validresult = this.validateKennzeichen(k);
    if(validresult<=0){
      this.handleInvalidKennzeichen(validresult);
      return
    }    
    k.edited = "added";
    this.pbKennzeichen.push(k);
    this.newPbKennzeichen.kennzeichen = '';    
    this.newPbKennzeichen.laendercode = this.laenderCodes.SCHWEIZ;
    this.newPbKennzeichen.typ = 1;    
  }

  editPbkennzeichen(pbk){
    pbk.edited = 'changing'
    //pbk.previous = pbk.kennzeichen;
    this.editingKennzeichen = pbk;
    this.newPbKennzeichen.kennzeichen = pbk.kennzeichen;
    this.newPbKennzeichen.typ = pbk.typ;

    this.newPbKennzeichen.laendercode = pbk.laendercode;
    //Object.assign(this.newPbKennzeichen, pbk);
    //this.newPbKennzeichen = pbk;

  }
  applyChangesPbkennzeichen(){
    this.newPbKennzeichen.kennzeichen = this.newPbKennzeichen.kennzeichen.toUpperCase().trim().replace(/\s/g, '');
    let previousKennzeichen = this.editingKennzeichen.kennzeichen;
    let previousTyp = this.editingKennzeichen.typ;
    let previousLand = this.editingKennzeichen.laendercode;
    let validresult = this.validateKennzeichen(this.newPbKennzeichen);
    
    if(validresult<=0){
      this.handleInvalidKennzeichen(validresult);
      return
    }
    else{      
      this.editingKennzeichen.kennzeichen = this.newPbKennzeichen.kennzeichen;
      this.editingKennzeichen.typ = this.newPbKennzeichen.typ;
      this.editingKennzeichen.laendercode = this.newPbKennzeichen.laendercode;
    }
    if((previousKennzeichen != this.editingKennzeichen.kennzeichen) || (previousTyp != this.editingKennzeichen.typ) || (previousLand != this.editingKennzeichen.laendercode) ){
      this.pbkennzeichen_edited='changed';      
      this.editingKennzeichen.edited = 'changed';
    }
    else{
      delete this.editingKennzeichen.edited;
    }
    
    this.newPbKennzeichen.kennzeichen = '';
    this.newPbKennzeichen.typ = 1;    
    this.newPbKennzeichen.laendercode = this.laenderCodes.SCHWEIZ;    
  }

  validateKennzeichen(kennzeichen): number{
    
    var tmp: string = kennzeichen.kennzeichen;
    tmp = tmp.replace(/ /g, "");
    tmp = tmp.toUpperCase();
    kennzeichen.kennzeichen = tmp;



    if(kennzeichen.laendercode == this.laenderCodes.SCHWEIZ){
      if(kennzeichen.kennzeichen.length<3){
        return -8;
      }      
      let kanton = tmp.substr(0,2);
      let rest = tmp.substr(2);
      
      if( this.pbData.KANTONE.includes(kanton) ){
        //-- Gültiger Kanton 
        
        if(/^[0-9]+$/i.test(rest)){
          //-- Gültiges Kennzeichen
          if(rest.length>=1){
            return 1;
          }
          else{
            return -7;
          }
        }
        else{
          
          //-- Prüfen ob Zoll- oder Garagenkennzeichen ------
          let lastcharachter = rest.slice(-1);
          let nummer = rest.slice(0,-1); 
          if(lastcharachter == "Z"){
            
            //-- Prüfen ob Charakter ausser letzte nur Nummern sind ------
            if(/^[0-9]+$/i.test(nummer)){
              if(nummer.length>=1){
                return 2; //Zollkennzeichen
              }
            }
            return -3;

          }
          else if (lastcharachter == "U"){
            //-- Prüfen ob Charakter ausser letzte nur Nummern sind ------
            if(/^[0-9]+$/i.test(nummer)){
              if(nummer.length>=1){
                return 3; //Garagennummer
              }
            }
            return -7;
          }
          else{
            return -7; //Kein gültiges Kennzeichen
          }

        }
        
      }
      else if(tmp.substr(0,1) == 'M'){
        //-- Militärkennzeichen ------
        rest = tmp.substr(1);
        if(!isNaN(+rest)){
          if(rest.length>=1){
            return 4;
          }
        }
        else{
          return -1;
        }
      }
      else{
        return -1; //-- Kein gültiger Kanton oder kein Gültiges Militärkennzeichen
      }
      return -2;
    }
    else{
      //-- Ausländisches Kennzeichen -----
      if(/^[a-z0-9]+$/i.test(kennzeichen.kennzeichen)){
        return 6; //gültiges ausländiesches kennzeichen
      }    
      else{
        return -7;
      }  
    }

  }
  handleInvalidKennzeichen(validationresult){
    let error = 'Ungültiges Kennzeichen';
    switch(validationresult) {
      case -1: 
        error = "kein gültiger Kanton";    
        break;
      case -7: 
        error = "nur Zahlen und Buchstaben";    
        break;

      case -8: 
        error = "mind. 3 Zeichen";    
        break;
      default:
    }
    this.common.showError(error, 5000);    
  }


  discardChangesPbkennzeichen(){
    this.newPbKennzeichen.kennzeichen = '';    
    this.newPbKennzeichen.typ = 1;    
    delete this.editingKennzeichen.edited;
  }
  addGrundstueckPeriodRule(event, regelindex, period){
    //console.log(period);
    period.attributes.edited = "changed";
    period.attributes.pbregelnbyperiode[regelindex].attributes.grundstuecke_grundid = event.grundid;

  }     

  discardPeriodChanges(pd){
    if(!pd.period.id || pd.period.id<0){
      pd.period.attributes.ignorechanges = true;
      this.navCtrl.pop();
      this.statusUpdateTimer = null;      
    }
    else{
      this.initPb();
  
  
    }
  }


  async updatePeriodChanges(pd){
    //console.log(pd);
    let validation = this.validatePbInputs(pd);
    //console.log("UpdatePeriodChanges Validation: " + validation);
    if(validation>0){
      if(pd.period.id && pd.period.id>0){
        this.pbData.updatepbperiode(pd.period).then(async (res:any) => {
          if(!res.success){
            this.common.showError(res.message, 12000);  
            return;
          }
          else{        
            //console.log(res);
            pd.period = res.data;     
            this.common.showMessage(res.message);  
            if(res.changed){
              let relevantestatus = [2,3,4,5,12];

              if(relevantestatus.includes(res.data.pbstatus_id)){

                
                //-- Kunde muss informiert werden ----
                let title = "Änderungen vorgenommen";
                let message = "<p>Es wurden relevante Änderungen an der Parkbewilligung vorgenommen. Die Bezüger*in sollte darüber informiert werden.</p>";
                if(this.pbKunde.kommunikation == "digital"){
                  message  = message + "<p>Soll die Bezüger*in per E-Mail informiert werden?</p>";
                }
                else{
                  if(res.data.pbstatus_id == 3){                    
                    message  = message + "<p>Soll die Quittung als PDF herunterladen werden?</p>";
                  }
                  else{
                    message  = message + "<p>Soll die Rechnung als PDF herunterladen werden?</p>";
                  }
                }
                let result = await this.common.openModal(title, message, [{text:'Ja', color:'primary', icon:'checkmark'}, {text:'Nein', color:'danger', icon:'close'}]);
                if(result == "Ja"){
                  if(this.pbKunde.kommunikation == "digital"){
                    this.pbData.sendpbchangenotification(pd.period.id);                        
                  }
                  else{
                    if(res.data.pbstatus_id == 3){
                      this.pbData.printinvoices_no_statechange(pd.period.id);                        
                    }
                    else{
                      this.pbData.printinvoices_no_statechange(pd.period.id);
                    }
                  }                    

                }
                else{
                  //-- No notification -----
                }
              }
              
            }

          }
          //-- refresh periode -----
          this.pbData.viewallbycustomer(this.pbkunden_id).then(res => {
            let tmp: any;
            tmp = res;
            
            for(let i =0; i< tmp.attributes.periods.length; i++){
              if(pd.period.id == tmp.attributes.periods[i].id){
                pd.period = tmp.attributes.periods[i];        
                delete pd.period.attributes.edited;
              }
            }
          });    
    
        });    
      }
      else{
        pd.period.attributes.pbkunde = this.pbKunde;
        this.pbData.createpbperiode(pd.period, pd.period.attributes.parkbewilligung.physisch).then( (res:any) => {

          if(!res || res.length <= 0){
            this.common.showError('Fehler beim Erzeugen der Parkbewilligung');
            return;
          }
          else{        
            this.pbkunden_id = res.attributes.pbkunde.id;
            this.pbperioden_id = res.id;
            this.customertab = "info";
            this.viewmode = 'edit';
            this.initPb();
          }  
    
        });           
      }

    }
    else{
      switch(validation){
        case -1: this.common.showError('Bitte Kategorie zuweisen');    
        return;
        case -2: this.common.showError('Bitte Zone zuweisen');    
        return;
        case -3: this.common.showError('Bitte Grundstück zuweisen');    
        return;
        case -4: this.common.showError('Bitte gültiges Kennzeichen zuweisen');    
        return;
      }  

    }
 }  
  assignnextperiodstate(pd, action_result){

    if (this.statusUpdateTimer) {
      console.log('still request pending');
      return;
    }
    else{

      this.statusUpdateTimer = setTimeout(() => {

        this.pbData.assignnextperiodstate(pd.period.id, action_result).then(res => {
          let tmp: any;
          //console.log(res);
          tmp = res;
    
          this.navCtrl.pop();
          this.statusUpdateTimer = null;
        });     
  
        
      }, 200);   

    }


    

  }
  discardPbKundeChanges(pbKunde){
    //console.log(pbKunde);
    if(!pbKunde.hasOwnProperty("id")){
      this.pbkennzeichen_edited = "";
      this.pbKunde.attributes.edited = "";
      this.navCtrl.pop();
    }
    else{
      let _expanded = pbKunde.attributes.expanded;
      this.pbData.viewallbycustomer(this.pbkunden_id).then(res => {
        let tmp: any;
        tmp = res;
        this.pbKunde = tmp.attributes.pbkunde;
        this.pbKunde.attributes = {expanded: _expanded};          
        this.pbKennzeichen = tmp.attributes.pbkennzeichen;
        this.pbkennzeichen_edited = "";
      });       
  
    }
  }  
  async validateKundenInputs(){
    if(!this.pbKunde.name){return -1;}
    this.pbKunde.name = this.pbKunde.name.trim();    
    if (this.pbKunde.name == ""){
      return -1;
    }

    if(!this.pbKunde.vorname){return -2;}
    this.pbKunde.vorname = this.pbKunde.vorname.trim();    
    if(this.pbKunde.vorname == ""){return -2;}
        
    if(!this.pbKunde.adresse1){return -3;}
    this.pbKunde.adresse1 = this.pbKunde.adresse1.trim();    
    if(this.pbKunde.adresse1 == ""){return -3;}
    if(this.pbKunde.adresse2){
      this.pbKunde.adresse2 = this.pbKunde.adresse2.trim();    
    }
    if(this.pbKunde.adresse3){
      this.pbKunde.adresse3 = this.pbKunde.adresse3.trim();    
    }

    if(!this.pbKunde.plz){return -4;}
    this.pbKunde.plz = this.pbKunde.plz.toString().trim();    
    if(this.pbKunde.plz == ""){return -4;}

    if(!this.pbKunde.ort){return -5;}
    this.pbKunde.ort = this.pbKunde.ort.trim();    
    if(this.pbKunde.ort == ""){return -5;}

    if(this.pbKunde.kommunikation == "digital"){
      if(!this.pbKunde.email){return -6;}
      this.pbKunde.email = this.pbKunde.email.trim();    
    	let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      let result = re.test(this.pbKunde.email );
      if(!result){
        return -6;
      }

      //-- E-Mail duplikatsprüfung nur bei Erzeugung
      if(this.createstep == "customercreate"){
        let emailresult:any = await this.kData.emailpresent(this.pbKunde.email);
        if(emailresult.success){
          if(emailresult.data){
            return -8;
          }
        }
        else{
          return -7;
        }
      }
    }
    return 1;
  }
  
  validatePbInputs(pd){
    if(!pd.period.pbkategorie_id || pd.period.pbkategorie_id<=0){
      return -1;
    }

    if((pd.period.attributes.mandat.pb_zone_grundstuecke === "zone")){
      
      //-- entfernte zonen nicht zählen ----------------
      let _zonencount = pd.period.attributes.pbzonen.length;
      for(let i =0; i< pd.period.attributes.pbzonen.length; i++){
        let _z = pd.period.attributes.pbzonen[i];
        if(_z && _z.hasOwnProperty("attributes") && _z.attributes.hasOwnProperty("edited")){
          if(_z.attributes.edited == "removed"){
            _zonencount = _zonencount - 1;
          }
        }
      }
      if((_zonencount<=0)){
        return -2;
      }
    }
    if((pd.period.attributes.mandat.pb_zone_grundstuecke === "grundstuecke") ){
      //-- entfernte grundstücke nicht zählen ----------------
      let _grundcount = pd.period.attributes.grundstuecke.length;
      for(let i =0; i< pd.period.attributes.grundstuecke.length; i++){
        let _g = pd.period.attributes.grundstuecke[i];
        if(_g && _g.hasOwnProperty("edited")){
          if(_g.edited == "removed"){
            _grundcount = _grundcount - 1;
          }
        }
      }      
      if((_grundcount<=0)){
        return -3
      }
    }

    if(pd.physisch == 0){
      if(!pd.period.pbkennzeichen_id || pd.period.pbkennzeichen_id<=0){
        return -4;
      }
    }

    return 1;
  }

  async updatePbKundeChanges(pbKunde, pbKennzeichen){    
    let _expanded = pbKunde.attributes.expanded;

    let validation = await this.validateKundenInputs();
    if(validation>0){
      if(this.createstep == "customercreate"){
        this.pbData.createpbkunde(pbKunde, pbKennzeichen).then(data => {    
          let res:any = data;  
          if(!res){
            return;
          }
          
          this.pbKunde= res.pbkunde;
          this.loadParkkarten(this.pbKunde.id);
          this.pbKunde.attributes = {expanded: false};          
          this.createstep = "pbcreate";
          if(res.pbkennzeichen){
            this.pbKennzeichen = res.pbkennzeichen;
          }
          else{
            this.pbKennzeichen = [];
          }
          this.pbkennzeichen_edited = "";

          let toast = this.toastCtrl.create({
            message: "Bezüger*in erfolgreich angelegt, mit + neue Parkbewilligung erfassen. ",
            position: 'top'
            ,duration: 5000
          });
    
          toast.present();         
        });  

      }
      else{
        this.pbData.updatepbkunde(pbKunde, pbKennzeichen).then(data => {    
          let res:any = data;  
          if(!res){
            let toast = this.toastCtrl.create({
              message: "Fehler beim Speichern",
              position: 'top',
              cssClass: 'toast-error',
              duration: 5000
            });
      
            toast.present();              
            return;
          }
          this.pbKunde= res.pbkunde;

          this.originalEmail = this.pbKunde.email;
          
          this.loadParkkarten(this.pbKunde.id);
          this.pbKunde.attributes = {expanded: _expanded};          
          
          if(res.pbkennzeichen){
            this.pbKennzeichen = res.pbkennzeichen;
          }
          else{
            this.pbKennzeichen = [];
          }
          this.pbkennzeichen_edited = "";

          let toast = this.toastCtrl.create({
            message: this.pbKunde.vorname+ ' ' +this.pbKunde.name + " gespeichert",
            position: 'top',
            cssClass: 'toast-error',
            duration: 3000
          });
    
          toast.present();         
        });  
  
      }
  
    }
    else{
      switch(validation){
        case -1: this.common.showError('Name darf nicht leer sein');
                 return;
        case -2: this.common.showError('Vorname darf nicht leer sein');
                 return;
        case -3: this.common.showError('Adresse1 darf nicht leer sein');
                 return;
        case -4: this.common.showError('PLZ darf nicht leer sein');
                 return;
        case -5: this.common.showError('Ort darf nicht leer sein');
                 return;
        case -6: this.common.showError('E-Mail ungültig');
                 return;
        case -7: this.common.showError('Fehler bei der E-Mail prüfung');
                 return;
        case -8: this.common.showError('E-Mail bereits vorhanden! Den bestehenden Kunden mit dieser E-Mailadresse suchen', 5000);
                 
                 setTimeout(() => {
                  this.createstep = "customerselect";
                  this.showKunden(this.pbKunde.email);
                  
                }, 200);   
                 
                 return;
      }      
    }

    
    
  }   
   save(){
/*
     Object.assign(this.oUE, this.oUECopy);
      Promise.all([
          this.ueData.update(this.oUECopy),            
        ]).then(data => {
          //console.log(data);
          this.navCtrl.pop();
          //refresh.complete();     
        });         
  */   


   }
   edit(){
    this.userData.editmode = this.userData.isAllowed('15','u');
    //this.editmode = 'edit';
   }

   removePeriodRule(period, pbregel, regelindex){
    this.zone.run(() => {       
      period.attributes.edited = "changed";      
      if(pbregel.attributes.edited && pbregel.attributes.edited == "removed"){
       delete pbregel.attributes.edited;
      }
      else if(pbregel.attributes.edited && pbregel.attributes.edited == "added"){
       //delete pbregel;
       period.attributes.pbregelnbyperiode.splice(regelindex,1);
      }
      else{
        period.attributes.pbregelnbyperiode[regelindex].attributes.edited = "removed";
      }
     });
      
   }

   readonly(){
    this.userData.editmode = false;
     //this.editmode = 'view';
   }   

   gridRowDataUpdated(event: any){ 
    //console.log(this.pbGrid2.api.getDisplayedRowCount());
   
    this.pbGrid2.api.forEachNode( function (node) {
      
      //this.pbGrid2.api.selectNode(node, true);
      //console.log(node);
      if (this.oPb.grundstuecke) {
        this.oPb.grundstuecke.forEach(grundstueck => {
          //console.log("1");
          if(grundstueck.grundid == node.data.grundid){
            //console.log("gridDataUpdate");
            node.setSelected(true, false);
          }
        });
      }
    }.bind(this));        
  }

  checkMandat(pd){
    //-- Admin -----
    if(this.userData.usergroup_id == 1){
      return true;
    }
    //-- Kein Mandat zugewiesen -----
    else if(this.userData.mandate_mandid.toString() == ""){
      return true;
    }
    //-- Neue Parkbewilligung immer anzeigen -------
    else if(!pd.period.id){
      return true;
    }

    else if (!pd.selectedkategorie){
      return false;
    }
    //-- Eine Periode des "eigenen" Mandats -----
    else if(pd.selectedkategorie.mandate_id == this.userData.mandate_mandid){
      return true;
    }
    else{
      return false;
    }
  }
  bestellungAblehnen(pd, result){
    //console.log(pd);
    this.confirmAblehnen(pd.period);
  }
  confirmAblehnen(pbperiode){
    let title = "";
    let param: any;
     
     title = "Bestellung ablehnen?";
    
     let alert = this.alertCtrl.create();
     alert.setTitle(title);
     alert.setSubTitle('Grund (wird Bezüger*in automatisch mitgeteilt)');
     alert.addInput({
         type: 'textarea',
         label: 'Grund',
         
     });

     alert.addButton({
       text: 'Ja, ablehnen',
       handler: (data: any) => {
          this.pbData.bestellungAblehnen(pbperiode.id, data[0]).then( (res:any) => {
            //let response = res.json();
            if(res && res.success){
              this.navCtrl.pop();
              this.statusUpdateTimer = null;
            }
            else{
              this.common.showError('Fehler beim Ablehnen', 5000);
            }
            //console.log(res);  
          });
           //this.testCheckboxOpen = false;
       }
     });
     alert.addButton('Abbrechen');

     alert.present();
     
  }    

  isPermanentKat(pbperiode){
    if(pbperiode && pbperiode.selectedkategorie){
      return (pbperiode.selectedkategorie.bestelltyp == PbKategorieTyp.Permanent);
    }
    
    return false;
  }


  
  
}



// WEBPACK FOOTER //
// ./src/pages/parkbewilligungen/parkbewilligungen-edit.ts